import React from "react";

const ApiDocumentation = () => {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto",
      }}
    >
      <h1>
        <span style={{ color: "#0D6EFD" }}>API Documentation</span>
      </h1>
      <h2
        style={{
          color: "rgb(211, 32, 32)",
        }}
      >
        Coming Soon...
      </h2>
    </div>
  );
};

export default ApiDocumentation;
